import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=5436d8be&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=5436d8be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5436d8be",
  null
  
)

export default component.exports